import { useState, useEffect } from "react";
import Head from "next/head";
import getConfig from "next/config";
import { connect } from "react-redux";

import withRouterPageLayout from "@components/withRouterPageLayout";
import { getPage } from "@store/pages/actions";
import Breadcrumbs from "@components/Breadcrumbs";
import ContentEditorView from "@components/ContentEditorView/index";
import Button from "@components/Button";
import Heading from "@components/Heading";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const PoliticaCookie = ({ pageRes }) => {
  const [isCookieConsentStateReady, setIsCookieConsentStateReady] =
    useState(false);

  let parsedEditorContent;

  if (pageRes.content_object && pageRes.content_object.length > 10) {
    try {
      parsedEditorContent = JSON.parse(pageRes.content_object);
    } catch (error) {
      parsedEditorContent = false;
    }
  }

  const handleCookieConsentChange = () => window.Cookiebot?.renew();

  useEffect(() => {
    let hasCookieConsentReadyEventListener = false;

    const handleCookieConsentReadyEvent = () =>
      setIsCookieConsentStateReady(true);

    if (window.Cookiebot?.hasResponse) {
      setIsCookieConsentStateReady(true);
    } else {
      window.addEventListener(
        "CookiebotOnConsentReady",
        handleCookieConsentReadyEvent
      );

      hasCookieConsentReadyEventListener = true;
    }

    return () => {
      if (hasCookieConsentReadyEventListener) {
        window.removeEventListener(
          "CookiebotOnConsentReady",
          handleCookieConsentReadyEvent
        );
      }
    };
  }, []);

  const fullWidthContainer = {
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    width: "100vw",
    position: "relative",
  };

  return (
    <>
      <Head>
        <title>{(pageRes && pageRes.title) || websiteTitle}</title>
        {!!pageRes.description && (
          <meta name="description" content={pageRes.description} />
        )}
        {!!pageRes.keywords && (
          <meta name="keywords" content={pageRes.keywords} />
        )}
      </Head>

      <Breadcrumbs
        breadcrumbs={[
          {
            id: 1,
            level: 99,
            name: pageRes.title,
          },
        ]}
      />

      {pageRes.content_heading && <h1>{pageRes.content_heading}</h1>}

      <div style={pageRes.template === "empty" ? fullWidthContainer : null}>
        {parsedEditorContent ? (
          <ContentEditorView content={parsedEditorContent} />
        ) : (
          <>
            {pageRes.content && (
              <div
                className="Cms"
                dangerouslySetInnerHTML={{ __html: pageRes.content }}
              />
            )}

            {isCookieConsentStateReady && (
              <>
                {/* TODO: This can also be found /cont/comunicare/
                Extract logic into one component or into a hook */}

                <Heading
                  as="h2"
                  display="h2"
                  title="Setari de confidentialitate"
                  classesProp="mb-4 pt-6"
                />

                <div className="flex flex-col md:flex-row gap-3 mt-4 w-full md:w-auto">
                  <Button
                    title="Schimbati consimtamantul"
                    variant="secondary"
                    onClick={handleCookieConsentChange}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

PoliticaCookie.getInitialProps = async (ctx) => {
  const { reduxStore, res } = ctx;

  const pageRes = await reduxStore.dispatch(
    getPage("politica-utilizare-cookie")
  );

  if (!pageRes) {
    if (res) {
      res.statusCode = 404;
    }
  }

  return {
    pageRes,
  };
};

PoliticaCookie.pageLayout = "default";

export default withRouterPageLayout(
  connect(null, {
    getPage,
  })(PoliticaCookie)
);
